export default __webpack_public_path__ + "static/media/product_1.4b9df6f1.webp";